export const OfflineFeesApprovalTabIcon = () => (
  <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.9997 13.2916C12.2653 13.2916 13.2913 12.2656 13.2913 10.9999C13.2913 9.73427 12.2653 8.70825 10.9997 8.70825C9.73402 8.70825 8.70801 9.73427 8.70801 10.9999C8.70801 12.2656 9.73402 13.2916 10.9997 13.2916Z'
      stroke='#D3E1EE'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M16.958 8.70825V13.2916'
      stroke='#D3E1EE'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M8.25033 16.4999C8.25033 17.1874 8.05784 17.8382 7.71867 18.3882C7.08617 19.4516 5.92199 20.1666 4.58366 20.1666C3.24533 20.1666 2.08115 19.4516 1.44865 18.3882C1.10948 17.8382 0.916992 17.1874 0.916992 16.4999C0.916992 14.4741 2.55783 12.8333 4.58366 12.8333C6.60949 12.8333 8.25033 14.4741 8.25033 16.4999Z'
      stroke='#D3E1EE'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M3.15527 16.4994L4.06276 17.4069L6.01527 15.6011'
      stroke='#D3E1EE'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M1.83301 14.0251V8.25008C1.83301 5.04175 3.66634 3.66675 6.41634 3.66675H15.583C18.333 3.66675 20.1663 5.04175 20.1663 8.25008V13.7501C20.1663 16.9584 18.333 18.3334 15.583 18.3334H7.79134'
      stroke='#D3E1EE'
      stroke-width='1.5'
      stroke-miterlimit='10'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)

export const OfflineFeesApprovalLogIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 18.2551C9.38 18.2551 7.25 16.1251 7.25 13.5051C7.25 10.8851 9.38 8.75513 12 8.75513C14.62 8.75513 16.75 10.8851 16.75 13.5051C16.75 16.1251 14.62 18.2551 12 18.2551ZM12 10.2551C10.21 10.2551 8.75 11.7151 8.75 13.5051C8.75 15.2951 10.21 16.7551 12 16.7551C13.79 16.7551 15.25 15.2951 15.25 13.5051C15.25 11.7151 13.79 10.2551 12 10.2551Z'
      fill='#008554'
    />
    <path
      d='M10.9999 15.2551C10.7499 15.2551 10.4999 15.1251 10.3599 14.8951C10.1499 14.5351 10.2599 14.0751 10.6199 13.8651L11.3799 13.4051C11.4599 13.3551 11.4999 13.2751 11.4999 13.1951V12.2651C11.4999 11.8551 11.8399 11.5151 12.2499 11.5151C12.6599 11.5151 12.9999 11.8451 12.9999 12.2551V13.1851C12.9999 13.7951 12.6699 14.3751 12.1499 14.6851L11.3799 15.1451C11.2699 15.2251 11.1299 15.2551 10.9999 15.2551Z'
      fill='#008554'
    />
    <path d='M10.02 4.46997L12 2' stroke='#008554' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
    <path
      d='M4.90988 7.79974C3.79988 9.27974 3.10986 11.1097 3.10986 13.1097C3.10986 18.0197 7.08988 21.9998 11.9999 21.9998C16.9099 21.9998 20.8899 18.0197 20.8899 13.1097C20.8899 8.19974 16.9099 4.21973 11.9999 4.21973C11.3199 4.21973 10.6599 4.30978 10.0199 4.45978'
      stroke='#008554'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
)
